var _circle, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _g, _circle2, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _g2, _rect, _rect2, _path18, _rect3, _path19, _ellipse, _ellipse2, _circle3, _circle4, _circle5, _path20, _path21, _path22, _path23, _circle6, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgKeycardIllustration(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 260,
    height: 200,
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 47.252,
    cy: 52.511,
    r: 22.757,
    stroke: "#4D4D4D",
    strokeWidth: 0.5
  })), /*#__PURE__*/React.createElement("mask", {
    id: "b",
    width: 46,
    height: 42,
    x: 24,
    y: 34,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "alpha"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#5C5C5C",
    strokeWidth: 0.5,
    d: "M59.917 48.5h-1.723"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#5C5C5C",
    strokeLinecap: "round",
    strokeWidth: 0.5,
    d: "M48.93 53.404c.358.818 1.766 2.452 4.524 2.452M38.157 52.996c.215.34.646 1.47.646 3.268M40.958 38.692c-.216-.613-1.422-1.758-4.525-1.43-4.955.521-5.817 8.173-2.154 12.26 2.154 2.404 2.843 5.354 2.154 8.787"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    stroke: "#5C5C5C",
    strokeWidth: 0.5,
    d: "m69.397 75.474-5.892-9.17a9.028 9.028 0 0 0-6.898-4.12l-1.35-.105a1.589 1.589 0 0 1-1.588-1.589v-.75"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    stroke: "#5C5C5C",
    strokeLinecap: "round",
    strokeWidth: 0.5,
    d: "M25.195 75.517V72.83a9.266 9.266 0 0 1 7.315-9.058l7.864-1.693.446-2.258a.861.861 0 0 1 .846-.695h8.125"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    stroke: "#5C5C5C",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.5,
    d: "M58.194 46.866c-.488-.342-1.557-.562-2.686-.205-.805.255-1.189 1.118-1.08 1.955.093.704.246 1.494.475 2.222.249.79-.072 1.816-.893 1.923a3.428 3.428 0 0 1-.556.03m-4.525-5.517c.807-.477 2.842-1.144 4.525 0M42.681 52.178c.2 1.072.414 4.616-.646 6.948"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    stroke: "#5C5C5C",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.5,
    d: "M53.885 40.122c.666.198 1.939.613 3.318 2.265M45.05 55.04c0 3.27 8.379 5.517 9.264 4.496 3.602-4.155 4.252-8.812 3.982-10.453a3.44 3.44 0 0 1-.067-.696c.112-2.738-.362-4.676-1.027-5.999m0 0c.373-.59.944-2.02.24-3.02-.069-.086-.254-.233-.573-.352-.466-.174-.934-.366-1.309-.694-2.434-2.125-7.53-4.811-12.319-1.662-6.495 4.27-5.064 11.248-3.743 13.748 1.057 2 2.826 3.715 3.303 4.062"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    stroke: "#5C5C5C",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.5,
    d: "M55.608 39.73c-1.124-.137-4.07.494-6.858 4.115-2.789 3.62-4.46 4.389-4.948 4.32-.45-.514-1.619-1.296-2.698-.308-1.35 1.234-.225 4.114 2.248 4.526"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    stroke: "#5C5C5C",
    strokeLinecap: "round",
    strokeWidth: 0.5,
    d: "m51.73 49.113-.215 1.022M56.685 49.113l-.215 1.022"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    stroke: "#5C5C5C",
    strokeWidth: 0.5,
    d: "M53.08 47.688c-1.326-.19-2.58-.074-3.559.113-.745.142-1.28.828-1.157 1.576.203 1.24.891 2.3 3.15 2.3 2.077 0 2.658-1.487 2.686-2.749.014-.64-.486-1.149-1.12-1.24ZM48.714 48.091h-4.956M58.823 47.558c-1.074-.158-2.086-.059-2.898.11a1.4 1.4 0 0 0-1.114 1.546c.168 1.261.758 2.351 2.759 2.351 1.818 0 2.324-1.494 2.346-2.757.012-.635-.465-1.157-1.093-1.25Z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#b)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 47.252,
    cy: 52.511,
    r: 22.757,
    fill: "#4D4D4D",
    stroke: "#4D4D4D",
    strokeWidth: 0.5
  }))), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 112.822,
    cy: 52.511,
    r: 22.757,
    stroke: "#4D4D4D",
    strokeWidth: 0.5
  })), /*#__PURE__*/React.createElement("mask", {
    id: "c",
    width: 45,
    height: 40,
    x: 91,
    y: 36,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "alpha"
    }
  }, _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    stroke: "#5C5C5C",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.5,
    d: "M115.123 52.51c.359.818 1.766 2.452 4.524 2.452"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    stroke: "#5C5C5C",
    strokeWidth: 0.5,
    d: "m134.967 75.474-5.892-9.17a9.026 9.026 0 0 0-6.898-4.12l-1.349-.105a1.588 1.588 0 0 1-1.589-1.589v-.75"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    stroke: "#5C5C5C",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.5,
    d: "M123.764 46.866c-.487-.342-1.557-.562-2.685-.205-.805.255-1.19 1.118-1.08 1.955.093.704.245 1.494.474 2.222.249.79-.072 1.816-.893 1.923a3.428 3.428 0 0 1-.556.03m-4.524-5.517c.806-.477 2.841-1.144 4.524 0"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    stroke: "#4D4D4D",
    strokeLinecap: "round",
    strokeWidth: 0.5,
    d: "M112.247 43.308c.958.767 4.486 2.07 10.928 1.15"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    stroke: "#5C5C5C",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.5,
    d: "M108.251 52.178c.201 1.072.414 4.616-.646 6.948"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    stroke: "#5C5C5C",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.5,
    d: "M123.783 48.74c.44 1.216 0 6.3-3.897 10.795-.886 1.022-9.265-1.226-9.265-4.496m-2.4 1.497c-.576-2.875-1.151-2.3-2.876-5.176-.384-1.726-1.036-5.867-.575-8.628.46-2.76 2.109-2.684 2.875-2.3.959-1.534 4.372-4.372 10.354-3.452.575.192 1.035.69-1.726 1.15 2.435-.383 6.343-.798 6.902 0 .32.458-1.284 1.151-1.725 1.151 3.067.384 9.778 2.876 1.725 5.177"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    stroke: "#5C5C5C",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.5,
    d: "M113.972 44.458c-1.038 1.349-1.725 6.327-3.451 6.327-1.149-.575 0-1.726-1.149-2.62-.449-.514-1.619-1.296-2.698-.308-1.349 1.234-.225 4.114 2.249 4.526"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    stroke: "#4D4D4D",
    strokeLinecap: "round",
    strokeWidth: 0.5,
    d: "M116 49.508c.575-.384 1.84-.92 2.3 0M122 49l.026 1M119.149 64.014c-4.921.757-8.622-1.418-10.527-3.387-.638-.66-1.587-1.01-2.458-.72l-9.745 3.248a2 2 0 0 0-1.206 1.11l-3.097 7.226"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#c)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 110.116,
    cy: 50.457,
    r: 19.75,
    fill: "#4D4D4D",
    stroke: "#4D4D4D",
    strokeWidth: 0.5
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 37.962,
    height: 3.451,
    x: 28.846,
    y: 80.119,
    fill: "url(#d)",
    rx: 1.726
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 37.962,
    height: 3.451,
    x: 94.416,
    y: 78.969,
    fill: "url(#e)",
    rx: 1.726
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    stroke: "#4D4D4D",
    strokeLinecap: "round",
    strokeWidth: 0.5,
    d: "M41.5 87.021h12.654M107.07 85.87h12.654"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 158,
    height: 79,
    x: 1,
    y: 18,
    stroke: "#4D4D4D",
    strokeWidth: 0.5,
    rx: 9
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#f)",
    fillOpacity: 0.3,
    stroke: "#4D4D4D",
    strokeWidth: 0.5,
    d: "M259.75 87c0 21.404-17.128 38.75-38.25 38.75S183.25 108.404 183.25 87s17.128-38.75 38.25-38.75S259.75 65.596 259.75 87Z"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 161.5,
    cy: 136,
    fill: "url(#g)",
    opacity: 0.3,
    rx: 21.5,
    ry: 22
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 207.5,
    cy: 162.5,
    fill: "url(#h)",
    opacity: 0.3,
    rx: 12.5,
    ry: 13.5
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 80.037,
    cy: 158.918,
    r: 21.032,
    stroke: "#4D4D4D",
    strokeWidth: 0.5
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 80.037,
    cy: 158.918,
    r: 29.084,
    stroke: "#4D4D4D",
    strokeDasharray: "1 1",
    strokeWidth: 0.5,
    opacity: 0.3
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 80.037,
    cy: 158.918,
    r: 39.437,
    stroke: "#4D4D4D",
    strokeWidth: 0.5,
    opacity: 0.1
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    stroke: "#4D4D4D",
    strokeLinecap: "round",
    strokeWidth: 0.5,
    d: "m159 59 29 9",
    opacity: 0.3
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    stroke: "#4D4D4D",
    strokeDasharray: "1 1",
    strokeLinecap: "round",
    strokeWidth: 0.5,
    d: "M79 97v40"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#i)",
    fillOpacity: 0.3,
    stroke: "#4D4D4D",
    strokeWidth: 0.5,
    d: "M222.5 34.75c-12.46 0-23.349-6.93-29.213-17.25C199.151 7.18 210.04.25 222.5.25s23.349 6.93 29.213 17.25c-5.864 10.32-16.753 17.25-29.213 17.25Z"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    stroke: "#4D4D4D",
    strokeDasharray: "1 1",
    strokeLinecap: "round",
    strokeWidth: 0.5,
    d: "M222.5 35v13"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 211,
    cy: 24,
    r: 5.75,
    fill: "url(#j)",
    fillOpacity: 0.3,
    stroke: "#4D4D4D",
    strokeWidth: 0.5
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "d",
    x1: 71.984,
    x2: 19.643,
    y1: 81.269,
    y2: 82.42,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4D4D4D",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "e",
    x1: 137.555,
    x2: 85.214,
    y1: 80.119,
    y2: 81.269,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4D4D4D",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "f",
    x1: 260,
    x2: 220.616,
    y1: -5.338,
    y2: 100.436,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4D4D4D",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g",
    x1: 183,
    x2: 152.697,
    y1: 83.912,
    y2: 168.891,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4D4D4D",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "h",
    x1: 220,
    x2: 200.623,
    y1: 130.537,
    y2: 182.021,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4D4D4D",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "i",
    x1: 256.556,
    x2: 220.825,
    y1: -82.868,
    y2: 11.72,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4D4D4D",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "j",
    x1: 217.927,
    x2: 201.137,
    y1: -10.412,
    y2: 15.955,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4D4D4D",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h260v200H0z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKeycardIllustration);
export default __webpack_public_path__ + "static/media/keycardIllustration.a1452ab286a485456bb83efd27604a3f.svg";
export { ForwardRef as ReactComponent };